class AffiliateSalesApi {
    static lock(ids) {
        return axios.post('/api/affiliate_sales/lock', {
            ids: ids,
        })
            .then(response => response.data);
    }
    static unlock(ids) {
        return axios.post('/api/affiliate_sales/unlock', {
            ids: ids,
        })
            .then(response => response.data);
    }
}

export default AffiliateSalesApi;
